import { Canvas } from '@react-three/fiber'
import { Fisheye, CameraControls, PerspectiveCamera, Environment, Grid } from '@react-three/drei'
import { Level, Sudo, Camera, Cactus, Box } from './Scene'

import { EffectComposer, Bloom, ToneMapping } from '@react-three/postprocessing'

export default function App() {
  return (
    <Canvas flat>
      <Fisheye zoom={0}>
        <CameraControls
          minPolarAngle={0}
          maxPolarAngle={Math.PI / 1.6}
          maxDistance={80} // maximum zoom-out
        />
        <ambientLight intensity={Math.PI / 2} />
        <group scale={20} position={[5, -11, -5]}>
          <Level />
          <Sudo />
          <Camera />
          <Cactus />
          <Box position={[-0.8, 1.4, 0.4]} scale={0.15} />
        </group>
        <Grid
          renderOrder={-1}
          position={[0, -10, 0]}
          infiniteGrid
          cellSize={0.6}
          cellThickness={0.6}
          sectionSize={3.3}
          sectionThickness={1.5}
          sectionColor={[0.5, 0.5, 10]}
          fadeDistance={60}
        />

        <Environment preset="warehouse" background blur={0.8} />
        <PerspectiveCamera makeDefault position={[0, 0, 18.5]} />
      </Fisheye>
    </Canvas>
  )
}
